export default () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="4 8 24 24"
        fill="none"
    >
        <g clipPath="url(#clip0_3630_7079)">
            <g clipPath="url(#clip1_3630_7079)">
                <g clipPath="url(#clip2_3630_7079)">
                    <g clipPath="url(#clip3_3630_7079)">
                        <path
                            d="M12.4422 26.25L9.77843 23.5862C8.60182 22.4096 8.06467 21.8693 7.70713 21.343C6.12885 19.0196 6.12885 15.9681 7.70714 13.6447C8.06468 13.1184 8.60183 12.5781 9.77844 11.4015C10.1606 11.0193 10.3016 10.8817 10.4297 10.7959C11.0307 10.3935 11.8205 10.4154 12.3982 10.8505C12.5214 10.9432 12.6545 11.0884 13.015 11.4912L13.2818 11.7893C13.8768 12.4542 14.1044 12.7153 14.2366 12.9851C14.5037 13.5299 14.5447 14.1583 14.3507 14.7332C14.2546 15.0178 14.0629 15.3063 13.5593 16.0428L13.3348 16.3711L13.3244 16.3864C13.1091 16.7013 12.9322 16.96 12.8025 17.1836C12.6675 17.4161 12.5654 17.6402 12.5175 17.8912C12.4396 18.2995 12.4788 18.7215 12.6308 19.1083C12.7243 19.3462 12.866 19.5476 13.0415 19.7512C13.2103 19.947 13.4319 20.1686 13.7016 20.4383L13.7147 20.4514L15.5368 22.2735L15.5499 22.2865C15.8194 22.556 16.0408 22.7775 16.2364 22.9461C16.4398 23.1215 16.641 23.2631 16.8787 23.3566C17.266 23.5089 17.6885 23.5483 18.0972 23.4701C18.3481 23.4221 18.572 23.32 18.8043 23.1852C19.0276 23.0556 19.2861 22.8788 19.6007 22.6637L19.616 22.6533L19.92 22.4454C20.6802 21.9257 20.9779 21.728 21.2726 21.6313C21.8364 21.4465 22.4498 21.4867 22.9846 21.7435C23.2642 21.8777 23.5336 22.1125 24.2196 22.727L24.5397 23.0138C24.9424 23.3745 25.0875 23.5077 25.1802 23.631C25.6147 24.2087 25.6364 24.998 25.2342 25.5986C25.1484 25.7267 25.0108 25.8678 24.6286 26.25C23.4512 27.4273 22.9105 27.9649 22.3838 28.3226C20.0607 29.9002 17.01 29.9002 14.687 28.3226L14.4061 28.7362L14.687 28.3226C14.1602 27.9649 13.6196 27.4274 12.4422 26.25Z"
                            stroke="currentColor"
                            strokeLinejoin="round"
                        />
                    </g>
                    <path
                        d="M24.1924 26.6863L19.9497 22.4436"
                        stroke="currentColor"
                    />
                    <path
                        d="M13.5857 16.0797L9.34305 11.837"
                        stroke="currentColor"
                    />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_3630_7079">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(4 8)"
                />
            </clipPath>
            <clipPath id="clip1_3630_7079">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(4 8)"
                />
            </clipPath>
            <clipPath id="clip2_3630_7079">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(15 38) rotate(-135)"
                />
            </clipPath>
            <clipPath id="clip3_3630_7079">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(15 38) rotate(-135)"
                />
            </clipPath>
        </defs>
    </svg>
);
